module.exports = __webpack_public_path__ + "70781ed4f0bf1a727bff103e3b2117e0.png";